<mat-icon svgIcon="chevron" class="chevron" [@rotatedState]="state"></mat-icon>
